<template>
    <div>

        <!-- components tabs start -->
        <div class="container-inner mg-top-90">
            <div class="container-fluid">
                <div class="row flex-row">
                    <div class="col-xl-12">
                        <div class="container">
                            <!-- Basic Tabs -->
                            <div class="widget-header text-center">
                                <h4>{{ $route.query.ref }} </h4>
                                <h4>Statement <span v-if="order.yourref" v-html="'for '+ order.yourref"></span></h4>
                            </div>
                            <div class="widget has-shadow ">
                                <!-- mg-top-90 -->
                                <div class="table-area ">
                                    <div class="container">
                                        <!-- <h5>Color Table</h5> -->
                                        <div class="ba-all-page-inner mb-4 p-0 border-radius-4">
                                            <div class="table-responsive" :style="'overflow-x: hidden !important;'">
                                                <!-- <table class="table table-dark table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">User ID</th>
                                                            <th scope="col">Name</th>
                                                            <th scope="col">Title</th>
                                                            <th scope="col">Balance</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">15323</th>
                                                            <td>John</td>
                                                            <td>Manager</td>
                                                            <td>$509.40</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">15324</th>
                                                            <td>Smith</td>
                                                            <td>User</td>
                                                            <td>$509.40</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">15325</th>
                                                            <td>Mark</td>
                                                            <td>User</td>
                                                            <td>$509.40</td>
                                                        </tr>
                                                    </tbody>
                                                </table> -->

                                                <d-table
                                                    classdivtable="availtable datatable nested table table-responsive"
                                                    refid="invoices" :busy="invoices.busy" :icon="invoices.icon"
                                                    :icons="invoices.icons" :tools="invoices.tools"
                                                    :fields="invoices.fields" :badges="invoices.badges"
                                                    :items="invoices.items" :downloaded="invoices.downloaded"
                                                    :showpages="false" :selectmode="'single'" :maxheight="2000"
                                                    @select="invoices_select" @click="invoices_click"
                                                    @load="invoices_load"></d-table>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <!-- <div class="widget-body sliding-tabs">
                                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="invoices-tab" data-bs-toggle="tab"
                                                data-bs-target="#invoices" type="button" role="tab"
                                                aria-controls="invoices" aria-selected="true">Transactions</button>
                                        </li> -->
                                <!-- <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="other-tab" data-bs-toggle="tab"
                                            data-bs-target="#other" type="button" role="tab" aria-controls="other"
                                            aria-selected="false">Other</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="audit-tab" data-bs-toggle="tab"
                                            data-bs-target="#audit" type="button" role="tab" aria-controls="audit"
                                            aria-selected="false">Audit</button>
                                    </li> -->
                                <!-- </ul>
                                    <div class="tab-content" id="myTabContent">
                                        <div class="tab-pane fade show active" id="invoices" role="tabpanel"
                                            aria-labelledby="invoices-tab"> -->
                                <!-- table 2 start -->
                                <!-- <div class="table-area mg-top-90">
                                                <div class="container">
                                                    <h5>Color Table</h5>
                                                    <div class="ba-all-page-inner mb-4 p-0 border-radius-4">
                                                        <div class="table-responsive">                                                           
                                                            <table class="table table-dark table-hover">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">User ID</th>
                                                                        <th scope="col">Name</th>
                                                                        <th scope="col">Title</th>
                                                                        <th scope="col">Balance</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <th scope="row">15323</th>
                                                                        <td>John</td>
                                                                        <td>Manager</td>
                                                                        <td>$509.40</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">15324</th>
                                                                        <td>Smith</td>
                                                                        <td>User</td>
                                                                        <td>$509.40</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">15325</th>
                                                                        <td>Mark</td>
                                                                        <td>User</td>
                                                                        <td>$509.40</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                            <d-table
                                                                classdivtable="availtable datatable nested table table-responsive"
                                                                refid="invoices" :busy="invoices.busy"
                                                                :icon="invoices.icon" :icons="invoices.icons"
                                                                :tools="invoices.tools" :fields="invoices.fields"
                                                                :badges="invoices.badges" :items="invoices.items"
                                                                :downloaded="invoices.downloaded" :showpages="false"
                                                                :selectmode="'single'" @select="invoices_select"
                                                                @click="invoices_click" @load="invoices_load"></d-table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div> -->
                            </div>
                            <!-- <div class="tab-pane fade" id="other" role="tabpanel"
                                        aria-labelledby="other-tab">
                                        Nam sagittis nec velit vitae molestie. Donec eget luctus sem. Nullam tortor
                                        tortor, consequat id lacinia nec, tempus in diam. Phasellus vel molestie purus,
                                        ac hendrerit risus. Phasellus non purus lacinia purus fringilla hendrerit. Sed
                                        pharetra odio a
                                        ante volutpat aliquam id non lacus.
                                    </div>
                                    <div class="tab-pane fade" id="audit" role="tabpanel"
                                        aria-labelledby="audit-tab">
                                        Nam sagittis nec velit vitae molestie. Donec eget luctus sem. Nullam tortor
                                        tortor, consequat id lacinia nec, tempus in diam. Phasellus vel molestie purus,
                                        ac hendrerit risus. Phasellus non purus lacinia purus fringilla hendrerit. Sed
                                        pharetra odio a
                                        ante volutpat aliquam id non lacus.
                                    </div> -->
                        </div>
                    </div>
                </div>
                <!-- End Basic Tabs -->
            </div>
        </div>
    </div>
    <!-- </div>
    </div> -->
    <!-- </div> -->

</template>

<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {

    name: "Invoices",
    data() {
        return {
            order: {},
            invoices: {
                debounce: 500,
                busy: false,
                icon: "fa fa-gbp",
                tools: "go,download,pdf",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-20px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-45px",
                    },
                    {
                        key: "invoiceno",
                        label: "Ref",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "refcredit",
                        label: "Cr Ref",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "dateref",
                        label: "Date",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("DD/MM/YY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "d-none d-md-table-cell",
                    },
                    // {
                    //     key: "datetravel",
                    //     label: "Date Travel",
                    //     sortable: true,
                    //     class: "text-center d-none d-sm-table-cell",
                    //     formatter: (value, key, item) => {
                    //         let result = "";
                    //         if (value) {
                    //             result = this.$moment
                    //                 .unix(value / 1000)
                    //                 .utc(false)
                    //                 .format("DD/MM/YY");
                    //         }
                    //         return result;
                    //     },
                    // },
                    {
                        key: "vatreclaim",
                        label: "rVAT",
                        sortable: true,
                        class: "text-right d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "outstanding",
                        label: "Due",
                        sortable: true,
                        class: "text-right d-none d-md-table-cell",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                    },

                    {
                        key: "saletotal",
                        label: "Amount",
                        sortable: true,
                        class: "text-right d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },

                    // {
                    //     key: "credit",
                    //     label: "Type",
                    //     sortable: true,
                    //     class: "text-center d-none d-sm-table-cell",
                    //     formatter: (value, key, item) => {
                    //         if (value == true) {
                    //             return "credit";
                    //         } else {
                    //             return "invoice";
                    //         }
                    //     },
                    // },
                    {
                        key: "actions",
                        label: "Action",
                        class: "actions w-50px text-center",
                    },
                ],
                icons: [
                    {
                        key: "credit",
                        invoice: "fa fa-long-arrow-up text-warning w-15px text-center",
                        credit: "fa fa-long-arrow-down text-gray w-15px text-center",
                    }
                ],
                badges: [],
                items: [],
                selected: [],
                downloaded: [],
                component: null,
            },
            fill: { gradient: ["green"] },
        }
    },
    watch: {
        "$route.query.id": {
            immediate: true,
            async handler(newVal, oldVal) {
                console.log('$route.query.id', newVal)
                await this.invoices_load(0)
            }
        }
    },
    methods: {
        async invoices_load(offset, limit, page) {

            if (!this.$route.query.id) { return }

            let state = this.invoices;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                id: this.$route.query.id
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query orders($id: String) {
                        orders(id: $id) {
                            id
                            yourref
                            value
                            invoices_yourref {
                                id
                                invoiceno: ref
                                credit
                                dateref
                                yourref
                                slac
                                eventcode
                                datetravel
                                saletotal
                                vatreclaim
                                outstanding
                                refcredit
                                dateref
                                datepaid
                            }
                            # invoices_other {
                            # id
                            # invoiceno: ref
                            # credit
                            # dateref
                            # yourref
                            # slac
                            # eventcode
                            # datetravel
                            # saletotal
                            # outstanding
                            # refcredit
                            # dateref
                            # datepaid
                            # }
                        }
                        }
                    `,
                    variables,
                    fetchPolicy: "no-cache",
                });

                this.order = response.data.orders[0]
                this.invoices.items = response.data.orders[0].invoices_yourref;

                for (var j = 0; j < this.invoices.items.length; ++j) {
                    this.invoices.items[j].credit = this.invoices.items[j].credit == true ? 'credit' : 'invoice'
                    //     if (this.invoices.items[j].evat == "0.00") {
                    //         let saletotal = this.invoices.items[j].saletotal
                    //         this.invoices.items[j].evat = (parseFloat(saletotal) - (parseFloat(saletotal) / 1.2)).toFixed(2)
                    //     }
                }


                // this.invoicesother.items = response.data.orders[0].invoices_other;

                // state.downloaded = []
                // if (limit == 0) {
                //     state.downloaded = response.data.bankingsimports
                // } else {
                //     state.items = response.data.bankingsimports;
                // }

            } catch (error) {
                console.log(error);
            }
            this.message = ""
            state.edit = false
            state.busy = false;
        },
        async invoices_click(a, ss) {
            console.log('invoices_click', a, ss)

            let state = this.invoices;

            switch (a) {
                case "selectall":
                    break;
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    // await this.bankingsimports_load(0);
                    break;
                case "filter":
                    state.filtershow = !state.filtershow;
                    break;
                case "discard":
                    this.errormessage = ""
                    this.component = null
                    // await this.bankingsimports_load(0)
                    break;
                case "go":
                    this.errormessage = ""
                    await this.invoices_load(0)
                    break;
                case "add":
                    state.item = {
                        amount: "0",
                        account_id: this.item.id
                    }
                    state.edit = !state.edit
                    break;
                case "edit":
                    state.edit = !state.edit
                    break;
                case "delete":
                    // await this.bankingsimports_delete(ss)
                    break;
                case "rename":
                    if (ss.length > 0) {
                        state.item = { ...ss[0] }
                    }
                    state.rename = !state.rename
                    break;
                case "import":
                    this.fileUpload = null
                    this.suggestedname = ""
                    state.importshow = !state.importshow
                    break;
                case "saveas":
                    // await this.bankingsimports_saveas(ss);
                    break;
                case "redo":
                    // await this.bankingsimports_redo(ss);
                    break;
                case "reorder":
                    // await this.bankingsimports_reorder(ss);
                    break;

                case "pdf":
                    if (ss.length > 0) {
                        await this.invoices_pdf(ss)
                    }
                    break;
            }
        },
        async invoices_select(ss, tools) {

            let state = this.invoices;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "import", "download", "add"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "saveas", "pdf"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm", "redo"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });

                if (state.selected.length > 0) {
                    state.item = state.selected[0]  // WHAT YOU SELECTED

                    let v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
                    if (state.item.date_at != 'NaN') {
                        v = this.$moment.unix(state.item.date_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    }
                    state.datefor_date_at = { startDate: v, endDate: v }
                } else {
                    state.item = {}
                }
            }
        },
        async invoices_pdf(ss) {
            let state = this.invoices;

            state.busy = true

            let documentpdf = null
            let documentname = ""

            let variables = {
                ref: ss[0].invoiceno,
                documentformat: "INV_1"
            };

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query SLTransactions($ref: String, $documentformat: String) {
                        SLTransactions(ref: $ref, documentformat: $documentformat) {
                            id
                            ref
                            documentpdf
                        }
                        }
                    `,
                    variables,
                });

                if (response.data.SLTransactions.length > 0) {
                    documentpdf = response.data.SLTransactions[0].documentpdf
                    documentname = "ref_" + response.data.SLTransactions[0].ref + ".pdf"

                    if (documentpdf) {
                        let byteCharacters = atob(documentpdf);
                        let byteNumbers = new Array(byteCharacters.length);
                        for (var i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        let byteArray = new Uint8Array(byteNumbers);
                        let blob = new Blob([byteArray], { type: "application/pdf" });
                        fs.saveAs(blob, documentname);
                    }
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false
        }

    }
}
</script>